import React from 'react';
/*
import {
  ht,
  hf,
  RclRoot,
  DsnRoot,
  NgnRoot,
  cr,
  cmODT,
} from 'lib';
*/
import * as cmODT from './src/_cmODT';
import { default as RclRoot } from "./src/_csRcl";
import { default as DsnRoot } from "./src/_csDsn";
import { default as NgnRoot } from "./src/_csNgn";
import * as ht from "./src/_ht";
import * as cr from "./src/_cr";

import * as icm from './src/icm';

import * as icvLgn___Rz from './src/icvLgn___Rz';

import * as icvLgnK10Rz from './src/icvLgnK10Rz';
import * as icvHomeK10Rz from './src/icvHomeK10Rz';


import * as icvHomeS10Rz from './src/icvHomeS10Rz';
import * as icvHomeS20Rz from './src/icvHomeS20Rz';
import * as icvHomeS30Rz from './src/icvHomeS30Rz';
import * as icvHomeS40Rz from './src/icvHomeS40Rz';
import * as icv_10S10Rz from './src/icv_10S10Rz';
import * as icv_41S10Rz from './src/icv_41S10Rz';
import * as icv_42S10Rz from './src/icv_42S10Rz';
import * as icv_51S10Rz from './src/icv_51S10Rz';
import * as icv_60K10Rz from './src/icv_60K10Rz';
import * as icv_61S10Rz from './src/icv_61S10Rz';
import * as icvI10S10Rz from './src/icvI10S10Rz';
import * as icvI11S10Rz from './src/icvI11S10Rz';
import * as icvI15S10Rz from './src/icvI15S10Rz';
import * as icvI16S10Rz from './src/icvI16S10Rz';
import * as icvI17S10Rz from './src/icvI17S10Rz';
import * as icvI18S10Rz from './src/icvI18S10Rz';
import * as icvI19K10Rz from './src/icvI19K10Rz';
import * as icvI20K10Rz from './src/icvI20K10Rz';

import * as icvLgnS10Rz from './src/icvLgnS10Rz';
import * as icvLgnS20Rz from './src/icvLgnS20Rz';
import * as icvI1zS10RzR from './src/icvI1zS10RzR';
import * as icvI1zS10RzE from './src/icvI1zS10RzE';
import * as icvI1zS20Rz from './src/icvI1zS20Rz';
import * as icvI1zS30Rz from './src/icvI1zS30Rz';
import * as icvI1zS40Rz from './src/icvI1zS40Rz';
import * as icv_70S10Rz from './src/icv_70S10Rz';

//import * as icvI1yS10Rz from './src/x_icvI1yS10Rz';

import * as icvLgnD10Rz from './src/icvLgnD10Rz';
import * as icvLgnD20Rz from './src/icvLgnD20Rz';
import * as icvLgnD30Rz from './src/icvLgnD30Rz';
import * as icvLgnD40Rz from './src/icvLgnD40Rz';

import * as icvHomeD10Rz from './src/icvHomeD10Rz';

import * as icvI1zD10RzR from './src/icvI1zD10RzR';
import * as icvI1zD10RzE from './src/icvI1zD10RzE';
import * as icvI1zD20Rz from './src/icvI1zD20Rz';
import * as icvI18D10Rz from './src/icvI18D10Rz';
import * as icvI18D20Rz from './src/icvI18D20Rz';




const App = () => {

  React.useEffect(() => {
    cmODT.chkClw(3000, (_drc: ht.n) => {
//      if (_drc >= 60) icm.lgt({ bTimeOut: true });
//      if (_drc >= 60) icm.lgt({ bTimeOut: true });
//hf.l(`App 71: ${_drc}`);
      if (_drc >= 60) icm.lgt({ bTimeOut: true });
      return false;
    })

  }, [
  ])

  return (
    cr.c(RclRoot, {
      key: -10 },
      cr.c(DsnRoot, {
        key: -10,
      },
          cr.c(NgnRoot, {
            key: -10,
            ls: [
              {
  //              pageName: 'Iccv00a',
                pageName: 'i',
                oCpt: icvLgn___Rz.N,
              },
              {
                pageName: 'icvLgnK10Rz',
                oCpt: icvLgnK10Rz.N,
              },
              {
                pageName: 'icvHomeK10Rz',
                oCpt: icvHomeK10Rz.N,
              },
              {
                pageName: 'icvHomeS10Rz',
                oCpt: icvHomeS10Rz.N,
              },
              {
                pageName: 'icvHomeS20Rz',
                oCpt: icvHomeS20Rz.N,
              },
              {
                pageName: 'icvHomeS30Rz',
                oCpt: icvHomeS30Rz.N,
              },
              {
                pageName: 'icvHomeS40Rz',
                oCpt: icvHomeS40Rz.N,
              },
              {
                pageName: 'icv_10S10Rz',
                oCpt: icv_10S10Rz.N,
              },
              {
                pageName: 'icv_41S10Rz',
                oCpt: icv_41S10Rz.N,
              },
              {
                pageName: 'icv_42S10Rz',
                oCpt: icv_42S10Rz.N,
              },
              {
                pageName: 'icv_51S10Rz',
                oCpt: icv_51S10Rz.N,
              },
              {
                pageName: 'icv_60K10Rz',
                oCpt: icv_60K10Rz.N,
              },
              {
                pageName: 'icv_61S10Rz',
                oCpt: icv_61S10Rz.N,
              },
              {
                pageName: 'icvI10S10Rz',
                oCpt: icvI10S10Rz.N,
              },
              {
                pageName: 'icvI11S10Rz',
                oCpt: icvI11S10Rz.N,
              },
              {
                pageName: 'icvI15S10Rz',
                oCpt: icvI15S10Rz.N,
              },
              {
                pageName: 'icvI16S10Rz',
                oCpt: icvI16S10Rz.N,
              },
              {
                pageName: 'icvI17S10Rz',
                oCpt: icvI17S10Rz.N,
              },
              {
                pageName: 'icvI18S10Rz',
                oCpt: icvI18S10Rz.N,
              },
              {
                pageName: 'icvI19K10Rz',
                oCpt: icvI19K10Rz.N,
              },
              {
                pageName: 'icvI20K10Rz',
                oCpt: icvI20K10Rz.N,
              },
              {
                pageName: 'icvI1zS10RzR',
                oCpt: icvI1zS10RzR.N,
              },
              {
                pageName: 'icvI1zS10RzE',
                oCpt: icvI1zS10RzE.N,
              },
              {
                pageName: 'sng',
                oCpt: icvI1zS20Rz.N,
              },
              {
                pageName: 'icvI1zS30Rz',
                oCpt: icvI1zS30Rz.N,
              },
              {
                pageName: 'icvI1zS40Rz',
                oCpt: icvI1zS40Rz.N,
              },
              {
                pageName: 'icv_70S10Rz',
                oCpt: icv_70S10Rz.N,
              },
              {
                pageName: 'icvLgnS20Rz',
                oCpt: icvLgnS20Rz.N,
              },
              {
                pageName: 'icvLgnS10Rz',
                oCpt: icvLgnS10Rz.N,
              },
/*
              {
                pageName: 'icvI1yS10Rz',
                oCpt: icvI1yS10Rz.N,
              },
*/
              {
                pageName: 'icvLgnD10Rz',
                oCpt: icvLgnD10Rz.N,
              },
              {
                pageName: 'icvLgnD20Rz',
                oCpt: icvLgnD20Rz.N,
              },
              {
                pageName: 'icvLgnD30Rz',
                oCpt: icvLgnD30Rz.N,
              },
              {
                pageName: 'set',
                oCpt: icvLgnD40Rz.N,
              },
              {
                pageName: 'icvHomeD10Rz',
                oCpt: icvHomeD10Rz.N,
              },
              {
                pageName: 'icvI18D10Rz',
                oCpt: icvI18D10Rz.N,
              },
              {
                pageName: 'icvI18D20Rz',
                oCpt: icvI18D20Rz.N,
              },
              {
                pageName: 'icvI1zD10RzR',
                oCpt: icvI1zD10RzR.N,
              },
              {
                pageName: 'icvI1zD10RzE',
                oCpt: icvI1zD10RzE.N,
              },
              {
                pageName: 'stt',
                oCpt: icvI1zD20Rz.N,
              },
            ]
          })
      ),
    )
  )
};

export default App;